import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=94d0074c"
import script from "./WarningDialog.vue?vue&type=script&lang=ts"
export * from "./WarningDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports